import { ICreditOffer, ICreditQualification } from "../types/global";

// Generated by Copilot- Start - 2026-03-02 12:49:12
/**
 * Checks if a user qualifies for a credit based on their selected offer codes
 * @param creditOffers - Array of credit offers from epoch
 * @param selectedGenrePackOfferIds - Record of selected genre pack offer IDs
 * @returns Array of credit qualifications for all credit offers
 */
export function checkCreditQualification(
  creditOffers: ICreditOffer[] | undefined,
  selectedGenrePackOfferIds: Record<string, string[]> = {}
): ICreditQualification[] {
  if (!creditOffers || creditOffers.length === 0) {
    return [];
  }

  const qualifications: ICreditQualification[] = [];

  creditOffers.forEach(creditOffer => {
    creditOffer.dependentOffers.forEach(dependentOffer => {
      const minCount = typeof dependentOffer?.minCount === "string" ? parseInt(dependentOffer.minCount, 10) : dependentOffer?.minCount || 0;
      const maxCount = typeof dependentOffer?.maxCount === "string" ? parseInt(dependentOffer.maxCount, 10) : dependentOffer?.maxCount || 0;
      const requiredOfferCodes = dependentOffer.offerCode;

      let qualifyingOffersSelected = 0
      Object.keys(selectedGenrePackOfferIds).forEach(key => {
        const offersForGenrePack = selectedGenrePackOfferIds[key];
        const matchFound = offersForGenrePack.some(offerCode => requiredOfferCodes.includes(offerCode));
        if (matchFound) {
          qualifyingOffersSelected += 1;
        }
      });

      // Check if the user qualifies
      const qualifies = qualifyingOffersSelected >= minCount && qualifyingOffersSelected <= maxCount;

      qualifications.push({
        qualifies,
        creditAmount: creditOffer.creditAmount,
        offerCode: creditOffer.code,
        offerName: creditOffer.displayName || creditOffer.name,
        requiredOffers: requiredOfferCodes,
        selectedCount: qualifyingOffersSelected,
        minCount,
        maxCount
      });
    });
  });

  return qualifications;
}

/**
 * Gets all qualified credits for a user
 * @param creditOffers - Array of credit offers from epoch
 * @param selectedGenrePackOfferIds - Record of selected genre pack offer IDs
 * @returns Array of qualified credit offers
 */
export function getQualifiedCredits(
  creditOffers: ICreditOffer[] | undefined,
  selectedGenrePackOfferIds: Record<string, string[]> = {}
): ICreditQualification[] {
  const allQualifications = checkCreditQualification(creditOffers, selectedGenrePackOfferIds);
  return allQualifications.filter(qualification => qualification.qualifies);
}

/**
 * Calculates total credit amount for a user
 * @param creditOffers - Array of credit offers from epoch
 * @param selectedGenrePackOfferIds - Record of selected genre pack offer IDs
 * @returns Total credit amount
 */
export function calculateTotalCredit(
  creditOffers: ICreditOffer[] | undefined,
  selectedGenrePackOfferIds: Record<string, string[]> = {}
): number {
  const qualifiedCredits = getQualifiedCredits(creditOffers, selectedGenrePackOfferIds);
  return qualifiedCredits.reduce((total, credit) => total + credit.creditAmount, 0);
}
// Generated by Copilot- End - 2026-03-02 12:49:12
